<div class="color-chart">
  <p>Less</p>
  <div class="chart-item">
  </div>
  <div class="chart-item level-1">
  </div>
  <div class="chart-item level-2">
  </div>
  <div class="chart-item level-3">
  </div>
  <div class="chart-item level-4">
  </div>
  <p>More</p>
</div>
